import React from "react";
import { SocialMediaPlatformColors } from "../utils/Enums";
import { getLinkedInOauthUrl } from "../utils/oauth";
import { SocialMediaButton } from "../AccountLinkingPage";
import LinkedInIcon from "src/img/noticeboard/linkedin.svg";

const LinkedInLogin = () => {
    return (
        <a href={getLinkedInOauthUrl()} style={{ width: "fit-content", display: "flex", textDecoration: "none" }}>
            <SocialMediaButton
                backgroundColor={SocialMediaPlatformColors.LINKEDIN}
            >
                <img src={LinkedInIcon} alt="LinkedIn Icon" style={{ marginRight: "12px" }} />
                Connect LinkedIn
            </SocialMediaButton>
        </a>
    );
};

export default LinkedInLogin;
